import { useDispatch, useSelector } from "react-redux";
import { setFilter } from "../../store/pointsSlice";
import { regionNameMap } from "../../data/regionMapping";
import "./Filters.css";
import GradientControl from "../GradientControl/GradientControl";
import DensityControl from "../DensityControl/DensityControl";

const Filters = () => {
    const dispatch = useDispatch();
    const filters = useSelector((state) => state.points.filters);
    const points = useSelector((state) => state.points.points);

    const getUniqueValues = (field) => {
        if (field === "region") {
            return Object.keys(regionNameMap)
                .filter(
                    (key) =>
                        ![
                            "Центральный",
                            "Северо-Западный",
                            "Южный",
                            "Северо-Кавказский",
                            "Приволжский",
                            "Уральский",
                            "Сибирский",
                            "Дальневосточный",
                        ].includes(key)
                )
                .map((region) => ({ value: region, label: region }));
        }
        const values = [...new Set(points.map((point) => point[field]))];
        return values.map((value) => ({ value, label: value }));
    };

    const filterOptions = {
        federalDistrict: [
            { value: "all", label: "Все" },
            ...getUniqueValues("federalDistrict"),
        ],
        region: [{ value: "all", label: "Все" }, ...getUniqueValues("region")],
        group: [
            { value: "all", label: "Все" },
            ...getUniqueValues("group").map(({ value }) => ({
                value,
                label:
                    value === "mining"
                        ? "Отходы горнодобычи"
                        : value === "alkaline"
                        ? "Щелочные отходы"
                        : value,
            })),
        ],
        wasteType: [
            { value: "all", label: "Все" },
            ...getUniqueValues("wasteType").map(({ value }) => ({
                value,
                label:
                    value === "solid"
                        ? "Твердые"
                        : value === "liquid"
                        ? "Жидкие"
                        : value,
            })),
        ],
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        dispatch(setFilter({ [name]: value }));
    };

    const renderSelect = (name, value, options, label) => (
        <div className="select-block">
            <label className="select-label">{label}</label>
            <div className="custom-select-wrapper">
                <select
                    name={name}
                    value={value}
                    onChange={handleFilterChange}
                    className="custom-select"
                >
                    {options.map(({ value, label }) => (
                        <option key={value} value={value}>
                            {label}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );

    return (
        <div className="filters">
            <h3 className="filters-title">Фильтры</h3>

            {renderSelect(
                "federalDistrict",
                filters.federalDistrict,
                filterOptions.federalDistrict,
                "Выбор федерального округа:"
            )}

            {renderSelect(
                "region",
                filters.region,
                filterOptions.region,
                "Выбор субъекта РФ:"
            )}

            {renderSelect(
                "group",
                filters.group,
                filterOptions.group,
                "Выбор группы отходов:"
            )}

            {renderSelect(
                "wasteType",
                filters.wasteType,
                filterOptions.wasteType,
                "Выбор вида отходов:"
            )}
            <GradientControl />
            <DensityControl />
        </div>
    );
};

export default Filters;
